<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="mb-1">
        <b-col>
          <search :search-action="searchData" />
        </b-col>
        <b-col md="auto">
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
        <b-col
          v-if="detailSearch"
          cols="12"
        >
          <filter-data :filter-action="getFilteredData" />
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(company)="data">
        <div>{{ data.item.company }}</div>
        <div class="font-small-3 text-primary">
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(city)="data">
        <div>{{ data.item.city }}</div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            primary-text="Görüntüle"
            :primary-action="$route.path + '/view/' + data.item.id"
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BRow, BCol, BTable, BPagination, BButton, BCardFooter,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import Search from '@/views/Customers/FilterData/Search.vue'
import FilterData from '@/views/Customers/FilterData/FilterData.vue'

const tableName = 'customers'
export default {
  name: 'CustomersIndex',
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    Search,
    FilterData,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'company',
          label: 'FİRMA ADI',
        },
        {
          key: 'phone',
          label: 'TELEFON',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'sector',
          label: 'SEKTÖR',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'city',
          label: 'BÖLGE',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.company AS company`,
          `${tableName}.phone AS phone`,
          'sectors.title AS sector',
          'cities.title AS city',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['customers/dataList']
    },
    dataCounts() {
      return this.$store.getters['customers/dataCounts']
    },
    saveData() {
      return this.$store.getters['customers/dataSaveStatus']
    },
    detailSearch() {
      return this.$store.getters['customers/detailSearch']
    },
    filterData() {
      return this.$store.getters['customers/filterData']
    },
    searchKeyword() {
      return this.$store.getters['customers/search']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.searchKeyword.keyword) {
        this.dataQuery.or_like = {
          'customers.company': this.searchKeyword.keyword,
          'customers.phone': this.searchKeyword.keyword,
          'customers.tax_number': this.searchKeyword.keyword,
        }
        this.getDataList()
      } else {
        this.dataQuery.or_like = {}
        this.getDataList()
      }
    },
    getFilteredData() {
      const where = {}
      if (this.filterData.id_sectors) {
        where['customers.id_sectors'] = this.filterData.id_sectors
      }
      if (this.filterData.id_meets) {
        where['customers.id_meets'] = this.filterData.id_meets
      }
      if (this.filterData.id_countries) {
        where['customers.id_countries'] = this.filterData.id_countries
      }
      if (this.filterData.id_cities) {
        where['customers.id_cities'] = this.filterData.id_cities
      }
      this.dataQuery.where = where
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('customers/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('customers/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
